module.exports = __webpack_public_path__ + "assets/livejournal.4aec4c2babb9c072e7c53f5ca6c415ba1858204cd35eb4f7f4198e3bd96b402d.jpg";